export const content = `
    <div :class="currentTab == idTab && activeClass" :data-tag-meta="taggingMeta">
        <div v-if="changeTab && tabSlot" v-on:click="onClick" :class="tabClass">
            <slot name="tab"></slot>
        </div>
        <slot v-if="currentTab == idTab"></slot>
    </div>
`;

export const tab = `
    <li v-on:click="onClick" :class="currentTab == idTab && activeClass" :data-tag-meta="taggingMeta">
        <slot></slot>
    </li>
`;
